import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ModifierConnection, Product, Modifier } from 'features/Product/@types'

export const initialState: ModifierConnection.InitialStateType = {
  modalState: 'CLOSE',
  isLoading: false,
  query: {
    pageIndex: 1,
    pageSize: 20,
    name: '',
    bomCategory: 'ASTRO_KITCHEN',
  },
  modifierConnection: {
    pagination: null,
    data: [],
  },
  product: {
    pagination: {
      sort: 'id',
      direction: 'desc',
      pageSize: 20,
      pageIndex: 1,
      numberOfElements: 0,
    },
    data: [],
  },
  selectedProduct: null,
  selectedModifiers: [],
}

export const SLICE_NAME = 'modifierConnection'

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    setModalState: (state, { payload }: PayloadAction<ModifierConnection.ModalStateType>) => {
      state.modalState = payload
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setQuery: (state, { payload }: PayloadAction<Partial<Product.QueryType>>) => {
      state.query = {
        ...state.query,
        ...payload,
      }
    },
    setModifierConnectionData: (
      state,
      { payload }: PayloadAction<ModifierConnection.InitialStateType['modifierConnection']>,
    ) => {
      state.modifierConnection = payload
    },
    setProductData: (
      state,
      { payload }: PayloadAction<ModifierConnection.InitialStateType['product']>,
    ) => {
      state.product = payload
    },
    setSelectedProduct: (
      state,
      { payload }: PayloadAction<ModifierConnection.InitialStateType['selectedProduct']>,
    ) => {
      state.selectedProduct = payload
    },
    setSelectedModifiers: (
      state,
      { payload }: PayloadAction<ModifierConnection.InitialStateType['selectedModifiers']>,
    ) => {
      state.selectedModifiers = payload
    },
    removeSelectedModifiersById: (state, { payload }: PayloadAction<number>) => {
      state.selectedModifiers = state.selectedModifiers.filter(
        (modifier) => modifier.id !== payload,
      )
    },
  },
})

export const {
  resetState,
  setModalState,
  setModifierConnectionData,
  setQuery,
  setIsLoading,
  setProductData,
  setSelectedProduct,
  setSelectedModifiers,
  removeSelectedModifiersById,
} = slice.actions
export default slice.reducer
